import { guideReaderParams } from './guidePractice.js';

// A URL is only a pointer. Supply the same already-authorised section and
// practice entries shown in the reader navigation; this helper never loads IDs.
const visibleEntries = entries => Array.isArray(entries)
    ? entries.filter(entry => entry && typeof entry.id === 'string' && entry.id.length > 0)
    : [];

export function resolveGroupedLocation({ sections, practiceNav, wantedId, loading = false, failed = false } = {}) {
    const visibleSections = visibleEntries(sections);
    const visiblePractice = visibleEntries(practiceNav);
    const requested = wantedId != null && wantedId !== '';
    const section = requested ? visibleSections.find(entry => entry.id === wantedId) || null : null;
    const practice = section || !requested ? null : visiblePractice.find(entry => entry.id === wantedId) || null;
    if (section || practice) return { section, practice, status: 'ready', remember: true };

    // A fallback may render while a paid pointer resolves, but it must not replace
    // the requested URL or overwrite Resume. Failed reads cannot prove it absent.
    const fallbackSection = visibleSections[0] || null;
    const fallbackPractice = fallbackSection ? null : visiblePractice[0] || null;
    const fallback = { section: fallbackSection, practice: fallbackPractice };
    if (requested) return { ...fallback, status: failed ? 'unavailable' : loading ? 'pending' : 'unavailable', remember: false };
    if (fallbackSection || fallbackPractice) return { ...fallback, status: 'ready', remember: !loading && !failed };
    return { ...fallback, status: failed ? 'unavailable' : loading ? 'pending' : 'empty', remember: false };
}

// Explicit navigation clears the previous item's notes/reveal context. A host
// may deliberately select Study or a pilot step in the same atomic URL update.
export function groupedReaderParams(currentParams, id, { view, articleStep, introPart, suppPart } = {}) {
    return guideReaderParams(currentParams, {
        item: typeof id === 'string' && id.length > 0 ? id : null,
        notes: null,
        introPart: typeof introPart === 'string' && introPart.length > 0 ? introPart : null,
        suppPart: typeof suppPart === 'string' && suppPart.length > 0 ? suppPart : null,
        view: typeof view === 'string' && view.length > 0 ? view : null,
        articleStep: typeof articleStep === 'string' && articleStep.length > 0 ? articleStep : null,
    });
}
